import React, { useState, useEffect } from "react";
import { useTheme } from '@mui/material/styles'; // Importar el hook para acceder al tema

function CustomTextarea({ label = "Detalle", rows = 4, value, onChange, disabled = false }) {
  const [isFocused, setIsFocused] = useState(false);
  const [message, setMessage] = useState(value);
  const theme = useTheme(); // Obtener el tema actual

  useEffect(() => {
    setMessage(value);
  }, [value]);

  const handleInputChangeMessage = (e) => {
    setMessage(e.target.value);
    onChange(e);
  };

  return (
    <div style={{ position: "relative", marginBottom: "20px" }}>
      <label
        style={{
          position: "absolute",
          top: message || isFocused ? "-8px" : "10px",
          left: "12px",
          fontSize: message || isFocused ? "12px" : "16px",
          color: isFocused ? "#1976d2" : "#999",
          backgroundColor: "#fff",
          padding: "0 4px",
          transition: "0.2s",
          pointerEvents: "none",
        }}
      >
        {label}
      </label>
      <textarea
        rows={rows}
        value={message}
        onChange={handleInputChangeMessage}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
        style={{
          width: "95%",
          resize: "none",
          padding: "12px",
          fontSize: "1rem",
          fontFamily: theme.typography.fontFamily, // Aplicar la fuente desde el tema global
          borderRadius: "4px",
          border: isFocused ? "2px solid #1976d2" : "1px solid #ccc",
          outline: "none",
          transition: "border 0.2s",
        }}
      />
    </div>
  );
}

export default CustomTextarea;
